'use client';

import dynamic from 'next/dynamic';

// Leaflet bruger `window` og kan ikke renderes på serveren.
const CoverageMap = dynamic(() => import('./CoverageMap'), {
  ssr: false,
  loading: () => (
    <div className="coverage-map-canvas" role="status" aria-live="polite">
      <p style={{ padding: '1rem' }}>Indlæser dækningskort …</p>
    </div>
  ),
});

export default function CoverageMapLoader() {
  return <CoverageMap />;
}
